import {performRequest, TRequestPromise} from 'shared/utils';

import {IContextRawData} from './context-types';

export const fetchContextData = (): TRequestPromise<IContextRawData> => performRequest(
    {
        url: '/context',
    },
);

export const fetchContextLookupValues = ({
    lookupType,
    id,
}: {lookupType: string; id?: string | number}) => performRequest(
    {
        url: ['/lookupValue', lookupType, id].filter(v => !!v).join('/'),
    },
);

export const postContextData = (
    data?: Record<string, any>,
): TRequestPromise<IContextRawData> => performRequest({
    url: '/context',
    method: 'POST',
    data,
});
